import React, { useEffect, useState } from "react";
import Procedure from '../../../../globalcomponents/patient360/medicalhistory/procedure'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
const PatientProcedure = (props) => {
  return (
    <>
      <Procedure data={props.formValues.patientdata} app="Site" />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(PatientProcedure));


